import { render, staticRenderFns } from "./ProductsChart.vue?vue&type=template&id=ec9c041c&"
import script from "./ProductsChart.vue?vue&type=script&lang=js&"
export * from "./ProductsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports